import React from 'react';
import styled from 'styled-components';
import DownFooter from './DownFooter';
import { NavLink } from 'react-router-dom';

const Footer = () => {
  return (
    <OuterWrapper>
    <Wrapper>
      <div className='main'>
        <div className="footer-column-logo-icons">
          <img src='/images/footer-logo.png' alt='Bakpoket Logo' className='logo-img-footer' />
          <SocialIcons className="social-icons">
              <a href="https://www.facebook.com/share/1EgAN769QW/" target="_blank" rel="noopener noreferrer">
                <img src="/images/fb.png" alt="Facebook" />
              </a>
              <a href="https://www.instagram.com/bakpoket_?igsh=MXAwdWM2Y2tiZTMwMQ==" target="_blank" rel="noopener noreferrer">
                <img src="/images/insta.png" alt="Instagram" />
              </a>
              <a href="https://x.com/bakpoketcoupons?t=PRJYpyLLuhefZGMt7jlsOg&s=08" target="_blank" rel="noopener noreferrer">
                <img src="/images/xlogo.png" alt="Twitter" />
              </a>
              <a href="http://www.linkedin.com/in/bakpoket-coupons-332255373" target="_blank" rel="noopener noreferrer">
                <img src="/images/linkedin.png" alt="LinkedIn" />
              </a>
          </SocialIcons>
        </div>
        <div className='right-in-footer'>
          <div className="footer-column">
            <h3>USEFUL LINKS</h3>
            <p><NavLink to={"/"} className='nav1'>Home</NavLink></p>
            <p><NavLink to={'/categories'} className='nav2'>Categories</NavLink></p>
            <p><NavLink  to={'/top-coupons'} className='nav3'>Top Coupons</NavLink> </p>
            <p><NavLink to={'/best-offers'} className='nav4'>Best Offers</NavLink></p>
          </div>

          <div className="footer-column">
            <h3>HELP & SUPPORT</h3>
            <p><NavLink to='/faqs' className='nav1'>FAQs</NavLink></p>
            <p><NavLink to='/terms-service' className='nav1'>How it Works</NavLink></p>
            <p><NavLink to='/terms-service' className='nav1'>Missing Cashback </NavLink></p>
            <p><NavLink to='/contactus' className='nav1'>Contact Us</NavLink></p>
          </div>

          <div className="no-width">
            <h3>BAKPOKET</h3>
            <p><NavLink to='/aboutus' className='nav1'>About Us</NavLink></p>
            <p><NavLink to='/careers' className='nav1'>Careers</NavLink></p>
            <p><NavLink to='/terms-service' className='nav1'>Terms & Conditions</NavLink></p>
            <p><NavLink to='/privacypolicy' className='nav1'>Privacy Policy</NavLink></p>
            <p 
            style={{display:'none'}}
            ><NavLink to='admin-dashboard' className='nav1' >Admin DashBoard</NavLink></p>
          </div>
        </div>
      </div>

      <DownFooter />
    </Wrapper>
    </OuterWrapper>
  );
};

const OuterWrapper = styled.section`
  background-color: #2a4157;
  padding: 6px 16px;
  display: flex;
  max-width: 100%;
  justify-content: center;
  align-items: center;
  @media (max-width: 480px) {
    padding: 0px 0px;
  }
`;

const Wrapper = styled.section`
  background-color: #2a4157;

  .logo-img-footer{
    margin: 0px auto;
    max-width: 9rem;
    display:flex;
    justify-content:center;
  }
  @media (max-width: 540px) {
    .logo-img-footer{
        max-width: 9rem !important ;
    }
}
@media (max-width: 576px) {
    .logo-img-footer{
        max-width: 80px  ;
    }
}
@media (max-width: 766px) {
    .logo-img-footer{
        max-width: 9rem;
        margin: 0px;
    }
}

  
  .nav1{
    text-decoration:none;
    // color: #999999;
    color: #ddd9d9;
    @media(max-width:480px){
      margin-left:0px;
    }
  }
  .nav2{
    text-decoration:none;
    color: #ddd9d9;
    @media(max-width:480px){
      margin-left:9px;
    }
  }
  .nav3{
    text-decoration:none;
    color: #ddd9d9;
    @media(max-width:480px){
      margin-left:9px;
    }
  }
  .nav4{
    text-decoration:none;
    color: #ddd9d9;
    @media(max-width:480px){
      margin-left:9px;
    }
  }

  .main {
    display: flex;
    justify-content: space-between;
    padding: 0px 120px 0 150px;
    gap:7rem;

    @media (max-width: 768px) {
      flex-direction: column !important;
      align-items: center !important;
      justify-content: center !important;
      padding: 7px 0px !important;
      text-align: center !important;
      gap:0px;
    }

    @media (max-width: 865px) {
      flex-direction: row;
      align-items: center ;
      justify-content: center ;
      padding: 30px 10px ;
      text-align: center ;
      gap:0px ;
    }
    
    @media (max-width: 992px) {
      flex-direction: row ;
      align-items: center ;
      justify-content: center ;
      padding: 30px 20px ;
      text-align: center ;
      gap:0px ;
    }
      
    @media (max-width: 1280px) {
      flex-direction: row ;
      align-items: center ;
      justify-content: center ;
      padding: 30px 0px 0px 30px;
      text-align: center ;
      gap:0px;
    }
  }

  .right-in-footer {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    margin-right:20px;

    @media (max-width: 865px) {
      display: flex;
      justify-content: space-between;
      gap: 0rem;
      margin:0px auto;
    }

    @media (max-width: 992px) {
      display: flex;
      justify-content: space-between;
      gap: 0rem;
    }
    @media (max-width: 768px) {
      display: flex;
      justify-content: space-between;
      gap: 0rem;
      height:400px;
    }
    @media (max-width: 769px) {
      display: flex;
      justify-content: space-between;
      gap: 1.5rem;
      flex-direction:row;
      height:auto;
      margin:0px;
    }
  }

  .footer-column {
    flex: 1 1 120px;
    margin: 20px 10px;
    width: 210px;

    .top-space {
      margin-top: 23px;
    }

    p {
      margin: 4px 0;
      color: #999999;
      font-size: 14px;

      @media (max-width: 768px) {
        font-size: 12px;
      }
    }

    span {
      color: #ef4766;
      font-weight: bold;
    }

    @media (max-width: 768px) {
      width: 100%;
      // max-width: 300px;
      margin: 10px 0;
      flex: auto;
      max-width: fit-content;
    }
  }
  .footer-column-logo-icons {
    flex: 1 1 120px;
    margin: 20px 10px;
    width: 210px;

    .top-space {
      margin-top: 23px;
    }

    p {
      margin: 4px 0;
      color: #999999;
      font-size: 14px;

      @media (max-width: 768px) {
        font-size: 12px;
      }
    }

    span {
      color: #ef4766;
      font-weight: bold;
    }

    @media (max-width: 385px) {
      width: 95% !important;
      
    }
    @media (max-width: 395px) {
      width: 95% ;
      
    }
    @media (max-width: 768px) {
      width: 80%;
      
      flex: auto;
      display:flex;
      justify-content: space-between;
    }
  }

  .no-width {
    flex: 1 1 220px;
    margin-top: 20px;

    p {
      margin: 4px 0;
      color: #999999;
      font-size: 14px;

      @media (max-width: 768px) {
        font-size: 12px;
      }
    }

    span {
      color: #ef4766;
      font-weight: bold;
    }

    @media (max-width: 768px) {
      // max-width: 300px;
      width: 100%;
      margin: 10px 0;
      flex: auto;
      max-width: fit-content;
    }
    @media (max-width: 992px) {
      flex: auto !important;
    }
  }

  .logo-social-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;

    .logo-img {
      width: 180px;
      margin-bottom: 10px;

      @media (min-width: 769px) {
        margin-bottom: 0;
      }
    }

    .social-icons {
      margin-top: 20px;
    }

    @media (min-width: 769px) {
      flex-direction: row;
      align-items: center;
      gap: 130px;
    }
  }

  h3 {
    color: #ef4766;
    font-size: 18px;
    margin-bottom: 10px;

    @media (max-width: 768px) {
      font-size: 14px;
    }
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 12px;
  margin-top:10px ;
  justify-content: center;

  img {
    width: 25px;
    height: 25px;
    cursor: pointer;
    transition: transform 0.2s ease;
    margin-top:15px;

    &:hover {
      transform: scale(1.1);
    }
  }

  @media (max-width: 768px) {
    justify-content: center;
    align-items:center;
    img {
      width: 25px;
      height: 25px;
      margin-top:0px;
    }
  }
`;

export default Footer;


// import React from 'react';
// import styled from 'styled-components';
// import DownFooter from './DownFooter';
// import { NavLink } from 'react-router-dom';

// const Footer = () => {
//   return (
//     <OuterWrapper>
//     <Wrapper>
//       <div className='main'>
//         <div className="footer-column-logo-icons">
//           <img src='/images/footer-logo.png' alt='Bakpoket Logo' className='logo-img-footer' />
//           <SocialIcons className="social-icons">
//               <a href="https://www.facebook.com/share/1EgAN769QW/" target="_blank" rel="noopener noreferrer">
//                 <img src="/images/fb.png" alt="Facebook" />
//               </a>
//               <a href="https://www.instagram.com/bakpoket_?igsh=MXAwdWM2Y2tiZTMwMQ==" target="_blank" rel="noopener noreferrer">
//                 <img src="/images/insta.png" alt="Instagram" />
//               </a>
//               <a href="https://x.com/bakpoketcoupons?t=PRJYpyLLuhefZGMt7jlsOg&s=08" target="_blank" rel="noopener noreferrer">
//                 <img src="/images/xlogo.png" alt="Twitter" />
//               </a>
//               <a href="http://www.linkedin.com/in/bakpoket-coupons-332255373" target="_blank" rel="noopener noreferrer">
//                 <img src="/images/linkedin.png" alt="LinkedIn" />
//               </a>
//           </SocialIcons>
//         </div>
//         <div className='right-in-footer'>
//           <div className="footer-column">
//             <h3>USEFUL LINKS</h3>
//             <p><NavLink to={"/"} className='nav1'>Home</NavLink></p>
//             <p><NavLink to={'/categories'} className='nav2'>Categories</NavLink></p>
//             <p><NavLink  to={'/top-coupons'} className='nav3'>Top Coupons</NavLink> </p>
//             <p><NavLink to={'/best-offers'} className='nav4'>Best Offers</NavLink></p>
//           </div>

//           <div className="footer-column">
//             <h3>HELP & SUPPORT</h3>
//             <p><NavLink to='/faqs' className='nav1'>FAQs</NavLink></p>
//             <p><NavLink to='/terms-service' className='nav1'>How it Works</NavLink></p>
//             <p><NavLink to='/terms-service' className='nav1'>Missing Cashback </NavLink></p>
//             <p><NavLink to='/contactus' className='nav1'>Contact Us</NavLink></p>
//           </div>

//           <div className="no-width">
//             <h3>BAKPOKET</h3>
//             <p><NavLink to='/aboutus' className='nav1'>About Us</NavLink></p>
//             <p><NavLink to='/careers' className='nav1'>Careers</NavLink></p>
//             <p><NavLink to='/terms-service' className='nav1'>Terms & Conditions</NavLink></p>
//             <p><NavLink to='/privacypolicy' className='nav1'>Privacy Policy</NavLink></p>
//             <p 
//             style={{display:'none'}}
//             ><NavLink to='admin-dashboard' className='nav1' >Admin DashBoard</NavLink></p>
//           </div>
//         </div>
//       </div>

//       <DownFooter />
//     </Wrapper>
//     </OuterWrapper>
//   );
// };

// const OuterWrapper = styled.section`
//   // background-color: #2a4157;
//   border:2px solid #2a4157;
//   padding: 6px 16px;
//   display: flex;
//   max-width: 100%;
//   justify-content: center;
//   align-items: center;
//   margin-top:  20px;
//   @media (max-width: 480px) {
//     padding: 0px 0px;
//   }
// `;

// const Wrapper = styled.section`
//   // background-color: #2a4157;

//   .logo-img-footer{
//     margin: 0px auto;
//     max-width: 9rem;
//     display:flex;
//     justify-content:center;
//   }
//   @media (max-width: 540px) {
//     .logo-img-footer{
//         max-width: 9rem !important ;
//     }
// }
// @media (max-width: 576px) {
//     .logo-img-footer{
//         max-width: 80px  ;
//     }
// }
// @media (max-width: 766px) {
//     .logo-img-footer{
//         max-width: 9rem;
//         margin: 0px;
//     }
// }

  
//   .nav1{
//     text-decoration:none;
//     // color: #999999;
//     color: #2a4157;
//     @media(max-width:480px){
//       margin-left:0px;
//     }
//   }
//   .nav2{
//     text-decoration:none;
//     color: #2a4157;
//     @media(max-width:480px){
//       margin-left:9px;
//     }
//   }
//   .nav3{
//     text-decoration:none;
//     color: #2a4157;
//     @media(max-width:480px){
//       margin-left:9px;
//     }
//   }
//   .nav4{
//     text-decoration:none;
//     color: #2a4157;
//     @media(max-width:480px){
//       margin-left:9px;
//     }
//   }

//   .main {
//     display: flex;
//     justify-content: space-between;
//     padding: 0px 120px 0 150px;
//     gap:7rem;

//     @media (max-width: 768px) {
//       flex-direction: column !important;
//       align-items: center !important;
//       justify-content: center !important;
//       padding: 7px 0px !important;
//       text-align: center !important;
//       gap:0px;
//     }

//     @media (max-width: 865px) {
//       flex-direction: row;
//       align-items: center ;
//       justify-content: center ;
//       padding: 30px 10px ;
//       text-align: center ;
//       gap:0px ;
//     }
    
//     @media (max-width: 992px) {
//       flex-direction: row ;
//       align-items: center ;
//       justify-content: center ;
//       padding: 30px 20px ;
//       text-align: center ;
//       gap:0px ;
//     }
      
//     @media (max-width: 1280px) {
//       flex-direction: row ;
//       align-items: center ;
//       justify-content: center ;
//       padding: 30px 0px 0px 30px;
//       text-align: center ;
//       gap:0px;
//     }
//   }

//   .right-in-footer {
//     display: flex;
//     justify-content: space-between;
//     gap: 1rem;
//     margin-right:20px;

//     @media (max-width: 865px) {
//       display: flex;
//       justify-content: space-between;
//       gap: 0rem;
//       margin:0px auto;
//     }

//     @media (max-width: 992px) {
//       display: flex;
//       justify-content: space-between;
//       gap: 0rem;
//     }
//     @media (max-width: 768px) {
//       display: flex;
//       justify-content: space-between;
//       gap: 0rem;
//       height:400px;
//     }
//     @media (max-width: 769px) {
//       display: flex;
//       justify-content: space-between;
//       gap: 1.5rem;
//       flex-direction:row;
//       height:auto;
//       margin:0px;
//     }
//   }

//   .footer-column {
//     flex: 1 1 120px;
//     margin: 20px 10px;
//     width: 210px;

//     .top-space {
//       margin-top: 23px;
//     }

//     p {
//       margin: 4px 0;
//       color: #2a4157;
//       font-size: 14px;

//       @media (max-width: 768px) {
//         font-size: 12px;
//       }
//     }

//     span {
//       color: #ef4766;
//       font-weight: bold;
//     }

//     @media (max-width: 768px) {
//       width: 100%;
//       // max-width: 300px;
//       margin: 10px 0;
//       flex: auto;
//       max-width: fit-content;
//     }
//   }
//   .footer-column-logo-icons {
//     flex: 1 1 120px;
//     margin: 20px 10px;
//     width: 210px;

//     .top-space {
//       margin-top: 23px;
//     }

//     p {
//       margin: 4px 0;
//       color: #999999;
//       font-size: 14px;

//       @media (max-width: 768px) {
//         font-size: 12px;
//       }
//     }

//     span {
//       color: #ef4766;
//       font-weight: bold;
//     }

//     @media (max-width: 385px) {
//       width: 95% !important;
      
//     }
//     @media (max-width: 395px) {
//       width: 95% ;
      
//     }
//     @media (max-width: 768px) {
//       width: 80%;
      
//       flex: auto;
//       display:flex;
//       justify-content: space-between;
//     }
//   }

//   .no-width {
//     flex: 1 1 220px;
//     margin-top: 20px;

//     p {
//       margin: 4px 0;
//       color: #999999;
//       font-size: 14px;

//       @media (max-width: 768px) {
//         font-size: 12px;
//       }
//     }

//     span {
//       color: #ef4766;
//       font-weight: bold;
//     }

//     @media (max-width: 768px) {
//       // max-width: 300px;
//       width: 100%;
//       margin: 10px 0;
//       flex: auto;
//       max-width: fit-content;
//     }
//     @media (max-width: 992px) {
//       flex: auto !important;
//     }
//   }

//   .logo-social-wrapper {
//     display: flex;
//     flex-direction: column;
//     align-items: center;

//     .logo-img {
//       width: 180px;
//       margin-bottom: 10px;

//       @media (min-width: 769px) {
//         margin-bottom: 0;
//       }
//     }

//     .social-icons {
//       margin-top: 20px;
//     }

//     @media (min-width: 769px) {
//       flex-direction: row;
//       align-items: center;
//       gap: 130px;
//     }
//   }

//   h3 {
//     color: #ef4766;
//     font-size: 18px;
//     margin-bottom: 10px;

//     @media (max-width: 768px) {
//       font-size: 14px;
//     }
//   }
// `;

// const SocialIcons = styled.div`
//   display: flex;
//   gap: 12px;
//   margin-top:10px ;
//   justify-content: center;

//   img {
//     width: 25px;
//     height: 25px;
//     cursor: pointer;
//     transition: transform 0.2s ease;
//     margin-top:15px;

//     &:hover {
//       transform: scale(1.1);
//     }
//   }

//   @media (max-width: 768px) {
//     justify-content: center;
//     align-items:center;
//     img {
//       width: 25px;
//       height: 25px;
//       margin-top:0px;
//     }
//   }
// `;

// export default Footer;
